module.exports = __webpack_public_path__ + "img/4.2cba2712.png";